import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import BaseComponent from '../../../../baseClasses/BaseComponent';
import SelectMemberList from '../SelectMemberList';
import SearchBar from '../../../../components/SearchBar/SearchBar';
import { filterUsers } from '../../../../components/SearchBar/utils/searchUtils';
import dataModel from '../../../../models/DataModel';
import './CompanyMembers.scss';
import LoadingDots from '../../../../components/LoadingDots';

export class CompanyMembers extends BaseComponent {
  constructor(props) {
    super(props);
    this.createSelectedMemberList = this.createSelectedMemberList.bind(this);
    this.handleMemberSearchChange = this.handleMemberSearchChange.bind(this);
    
    this.state = {
      memberSearchTerm: '',
      filteredMembers: [],
    };
  }

  handleLoadMarket() {
    const { companyId, marketId } = this.props;
    this.setState({ loadingMarkets: true }, () => {
      dataModel.marketsDAO.getMarket(marketId, companyId, {
        recordDescriptor: {
          market:
          {
            market_users:
              // TODO: show market uses special serialization and as such
              // does not handle profile_image (which is not a true attribute)
              // may need to handle that eventually (or figure out why it is
              // not)
              //{ user: { additionalFields: ["profile_image"]} },
              { user: {} },
            market_vendor_users:
            {
              //vendor_user: { additionalFields: ["profile_image"], companies: {}},
              vendor_user: { companies: {} },
            },
            // vendor_users: { additionalFields: ["profile_image"], companies: {}},
            vendor_users: { companies: {} },
          },

        },
      }).then(market => {
        this.setState({ loadingMarkets: false });
        if (market) {
          let users = [];
          if (market.market_users) {
            market.market_users.forEach(market_user => {
              if (market_user.user && market_user.user.id && !market_user.user.suspended) {
                users.push(market_user.user);
              }
            });
          }
          this.setState({ users: users, market: market });
        }
      });
    });
  }

  componentDidMount() {

    dataModel.companiesDAO.getCompany(this.props.companyId,
      {
        recordDescriptor: {
          company: {
            vendor_companies: { additionalFields: ['is_vendor_company'] },
            teams: {},
            additionalFields: ['logo'],
          },
        },
      })
      .then(projectCompany => {
        this.setState({
          projectCompany: projectCompany,
        });
      });

    if (this.props.marketId) {
      this.handleLoadMarket();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.requestClose != this.props.requestClose) {
      this.handleClose();
    }
  }

  createSelectedMemberList() {
    let selectedMembers = null;
    if (this.props.projectMembers && this.props.projectMembers.length > 0) {
      selectedMembers = this.props.projectMembers.filter(member => {
        if (member.first_name) {
          member.name = member.first_name + ' ' + member.last_name;
        }
        return true;
      }, this);

      selectedMembers.sort((u1, u2) => {
        if (u1.name.toLowerCase() < u2.name.toLowerCase()) {
          return -1;
        } else if (u1.name.toLowerCase() > u2.name.toLowerCase()) {
          return 1;
        } else {
          return 0;
        }
      });
    }
    return selectedMembers;
  }

  handleMemberSearchChange(searchTerm) {
    const availableMembers = this.createMemberSelectionList();
    const filteredMembers = filterUsers(availableMembers, searchTerm);
    this.setState({ memberSearchTerm: searchTerm, filteredMembers });
  }

  createMemberSelectionList() {
    if (this.state.users) {
      const { projectMembers } = this.props;
      let users = [];
      users = this.state.users.map(user => {
        user.company = Object.assign({}, this.props.currentCompany);
        return user;
      });
      let membersSelectionList = !users ? [] : users.filter(user => {
        let findUser = null;
        if (projectMembers) {
          findUser = projectMembers.find((member) => {
            if (member.first_name || member.last_name) {
              return member.id == user.id;
            }
            else {
              // check the team users...
              return member.users.find((teamUser) => {
                return teamUser.id == user.id;
              });
            }
          });
        }
        if (user.super_admin || findUser) {
          return false;
        }
        else {
          user.name = user.first_name + ' ' + user.last_name;
          return true;
        }
      });
      return membersSelectionList.sort((u1, u2) => {
        return u1.name < u2.name ? -1 : u1.name > u2.name ? 1 : 0;
      });
    }
    return [];
  }

  cancelChange = () => {
    dataModel.systemPopup = null;
  };

  render() {
    const selectedMembers = this.createSelectedMemberList();
    const membersSelectionList = this.createMemberSelectionList();
    
    // Use filtered members if search term exists, otherwise use all members
    const displayMembers = this.state.memberSearchTerm ? this.state.filteredMembers : membersSelectionList;
 
    return (
      <div className="company-members">
        <div className="left-side">
          <div className="selection-section user-section">
            <div className="label taller">{this.textMap.selectMember}</div>
            
            {/* Search Bar */}
            <div className="member-search-container">
              <SearchBar
                placeholder="Search members by name or email..."
                onSearchChange={this.handleMemberSearchChange}
                width="100%"
                height="28px"
                debounceMs={300}
              />
            </div>
           
            <SelectMemberList
              members={displayMembers}
              selectMember={this.props.handleAddMember}
            />
            {this.state.loadingMarkets && <LoadingDots />}
            <div className="instructions">Click to Add</div>
          </div>
        </div>
        <div className="right-side">
          <div className="selection-section user-section">
            <div className="label">Selected Members</div>
            <SelectMemberList
              members={selectedMembers}
              selectMember={this.props.handleRemoveMember}
            />
            <div className="instructions">{'Click to Remove'}</div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.new_users.currentUser,
    permissions: state.new_users.permissions,
    currentCompany: state.new_companies.currentCompany,
  };
};

export default connect(mapStateToProps)(CompanyMembers);



// WEBPACK FOOTER //
// ./src/containers/PORContainer/EmailUserSelectionPopup/CompanyMembers/index.js